import {
    apiConstants,
    config,
    mockRejectApiCall,
    mockResolveApiCall,
    requestOptions,
    requestTypes,
    sendRequest
} from "../../Utilities/Api";
import {isObjectNullOrEmpty} from "../../Utilities/Types/objectUtilities";
import {accountExists, isLinkExpired} from "../User/userMockData";

class ServerPasswordApi {

    static forgotPassword(email: string) {

        return sendRequest(
            requestOptions(`${config.URL}passwords/forgot/`,
                requestTypes.POST,
                JSON.stringify(email),
                apiConstants.successMessage.user.FORGOT_PASSWORD,
            ),
        );
    }
    static updatePassword(updatePasswordViewModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(`${config.URL}passwords/update/`,
                requestTypes.PUT,
                JSON.stringify(updatePasswordViewModel),
                apiConstants.successMessage.user.UPDATE_PASSWORD,
            ),
        );
    }

    static validateUpdatePasswordLink(updatePasswordToken: string) {
        return sendRequest(
            requestOptions(`${config.URL}passwords/tokens/${updatePasswordToken}/validate`,
                requestTypes.GET,
            ),
        );
    }
}

class MockPasswordApi {
    static forgotPassword(email: string) {
        if (!accountExists(email)) {
            return mockRejectApiCall(apiConstants.errorMessage.user.FORGOT_PASSWORD_INVALID_EMAIL);
        }
        return mockResolveApiCall(true, apiConstants.successMessage.user.FORGOT_PASSWORD);
    }

    static updatePassword(updatePasswordViewModel: Record<string, unknown>) { 
        if (isObjectNullOrEmpty(updatePasswordViewModel)) {
            return mockRejectApiCall("There was an error while attempting to update your password.");
        }
        return mockResolveApiCall(true, apiConstants.successMessage.user.UPDATE_PASSWORD);
    }

    static validateUpdatePasswordLink(updatePasswordToken: string) {
        if (isLinkExpired(updatePasswordToken)) {
            return mockRejectApiCall("Reset password link is expired");
        }
        return mockResolveApiCall(true); 
    }
}

export const passwordApi = config.environment.MODE === config.modes.SERVER ? ServerPasswordApi : MockPasswordApi;
